import { render } from "./customer-login.vue?vue&type=template&id=11f0172c"
import script from "./customer-login.vue?vue&type=script&lang=js"
export * from "./customer-login.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__